// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionRule } from './ConditionRule';
import {
  ConditionRuleFromJSON,
  ConditionRuleFromJSONTyped,
  ConditionRuleToJSON,
  ConditionRuleToJSONTyped,
} from './ConditionRule';

/**
 *
 * @export
 * @interface ConditionRules
 */
export interface ConditionRules {
  /**
   *
   * @type {Array<ConditionRule>}
   * @memberof ConditionRules
   */
  clusters?: Array<ConditionRule>;
  /**
   *
   * @type {Array<ConditionRule>}
   * @memberof ConditionRules
   */
  isolationUnits?: Array<ConditionRule>;
  /**
   *
   * @type {Array<ConditionRule>}
   * @memberof ConditionRules
   */
  partitions?: Array<ConditionRule>;
}

/**
 * Check if a given object implements the ConditionRules interface.
 */
export function instanceOfConditionRules(
  value: object,
): value is ConditionRules {
  return true;
}

export function ConditionRulesFromJSON(json: any): ConditionRules {
  return ConditionRulesFromJSONTyped(json, false);
}

export function ConditionRulesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConditionRules {
  if (json == null) {
    return json;
  }
  return {
    clusters:
      json['clusters'] == null
        ? undefined
        : (json['clusters'] as Array<any>).map(ConditionRuleFromJSON),
    isolationUnits:
      json['isolation_units'] == null
        ? undefined
        : (json['isolation_units'] as Array<any>).map(ConditionRuleFromJSON),
    partitions:
      json['partitions'] == null
        ? undefined
        : (json['partitions'] as Array<any>).map(ConditionRuleFromJSON),
  };
}

export function ConditionRulesToJSON(json: any): ConditionRules {
  return ConditionRulesToJSONTyped(json, false);
}

export function ConditionRulesToJSONTyped(
  value?: ConditionRules | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusters:
      value['clusters'] == null
        ? undefined
        : (value['clusters'] as Array<any>).map(ConditionRuleToJSON),
    isolation_units:
      value['isolationUnits'] == null
        ? undefined
        : (value['isolationUnits'] as Array<any>).map(ConditionRuleToJSON),
    partitions:
      value['partitions'] == null
        ? undefined
        : (value['partitions'] as Array<any>).map(ConditionRuleToJSON),
  };
}
